/* SKINFOUNDRY motion system: reveals, word reveals, parallax, film hero, mode explorer.
   Re-entrant: sections replaced by the theme editor or dev live-reload are re-scanned.
   All effects respect prefers-reduced-motion. */
(function () {
  'use strict';
  document.documentElement.classList.add('sf-js');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal observer (shared) ---- */
  var rvIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('sf-in'); rvIO.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });

  /* ---- parallax registry ---- */
  var plxEls = [];
  var plxTicking = false;
  function updatePlx() {
    plxTicking = false;
    var vh = window.innerHeight;
    plxEls.forEach(function (el) {
      if (!el.isConnected) return;
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var speed = parseFloat(el.dataset.sfPlx) || 0.12;
      var mid = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translateY(' + (-mid * speed).toFixed(1) + 'px)';
    });
  }
  if (!reduced) {
    window.addEventListener('scroll', function () {
      if (!plxTicking) { plxTicking = true; requestAnimationFrame(updatePlx); }
    }, { passive: true });
  }

  /* ---- floating buy pill: shown once the buy strip scrolls past ---- */
  var pillTick = false;
  function updatePill() {
    pillTick = false;
    var pill = document.querySelector('.sf-buypill');
    if (!pill) return;
    var strip = document.querySelector('.sf-buystrip');
    var past = strip ? strip.getBoundingClientRect().bottom < 0 : window.scrollY > 900;
    pill.classList.toggle('sf-on', past);
  }
  window.addEventListener('scroll', function () {
    if (!pillTick) { pillTick = true; requestAnimationFrame(updatePill); }
  }, { passive: true });

  function initFilmHero(hero) {
    var video = hero.querySelector('video');
    if (!video) return;
    setTimeout(function () { hero.classList.add('sf-go'); }, 150);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { video.play().catch(function () {}); }
        else { video.pause(); }
      });
    }, { threshold: 0.25 });
    io.observe(hero);
    var soundBtn = hero.querySelector('.sf-film-sound');
    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        soundBtn.textContent = video.muted ? '🔇' : '🔊';
        soundBtn.setAttribute('aria-label', video.muted ? 'Unmute film' : 'Mute film');
      });
    }
  }

  function initModes(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.sf-mode-tab'));
    var imgs = Array.prototype.slice.call(root.querySelectorAll('.sf-mode-stage img'));
    var stage = root.querySelector('.sf-mode-stage');
    var counter = root.querySelector('.sf-mode-counter');
    var tabsWrap = root.querySelector('.sf-mode-tabs');
    if (!tabs.length) return;
    var idx = 0, timer = null, paused = reduced;

    function activate(i, fromUser) {
      idx = (i + tabs.length) % tabs.length;
      tabs.forEach(function (t, j) { t.classList.toggle('sf-on', j === idx); });
      imgs.forEach(function (im, j) { im.classList.toggle('sf-on', j === idx); });
      if (counter) counter.textContent = '0' + (idx + 1) + ' / 0' + tabs.length;
      if (stage) {
        var glow = tabs[idx].dataset.sfGlow || 'rgba(176,141,87,.35)';
        stage.style.boxShadow = '0 0 90px -18px ' + glow;
      }
      if (fromUser) pause();
      else if (!paused) queue();
    }
    function queue() {
      clearTimeout(timer);
      timer = setTimeout(function () { activate(idx + 1, false); }, 6000);
    }
    function pause() {
      paused = true;
      clearTimeout(timer);
      if (tabsWrap) tabsWrap.classList.add('sf-paused');
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i, true); });
    });
    root.querySelectorAll('.sf-mode-nav').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(idx + (btn.classList.contains('sf-next') ? 1 : -1), true);
      });
    });
    if (stage) {
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 42) activate(idx + (dx < 0 ? 1 : -1), true);
        sx = null;
      }, { passive: true });
    }
    var seenIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { activate(0, false); seenIO.unobserve(root); }
      });
    }, { threshold: 0.3 });
    seenIO.observe(root);
    activate(0, false);
  }

  function initGallery(root) {
    var mains = Array.prototype.slice.call(root.querySelectorAll('.sf-gal-main img'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.sf-gal-thumbs button'));
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        mains.forEach(function (m, j) { m.classList.toggle('sf-on', j === i); });
        thumbs.forEach(function (b, j) { b.classList.toggle('sf-on', j === i); });
      });
    });
  }

  /* ---- scan: idempotent init of everything inside root ---- */
  function scan(root) {
    root = root || document;

    root.querySelectorAll('.sf-words[data-sf-split]').forEach(function (el) {
      if (el.dataset.sfSplitDone) return;
      el.dataset.sfSplitDone = '1';
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'sf-w';
        s.style.transitionDelay = (i * 45) + 'ms';
        s.textContent = w;
        el.appendChild(s);
        el.appendChild(document.createTextNode(' '));
      });
    });

    root.querySelectorAll('.sf-rv,.sf-imgrv,.sf-words,.sf-rulerv').forEach(function (el) {
      if (el.dataset.sfRvSeen) return;
      el.dataset.sfRvSeen = '1';
      rvIO.observe(el);
    });

    root.querySelectorAll('[data-sf-plx]').forEach(function (el) {
      if (el.dataset.sfPlxSeen) return;
      el.dataset.sfPlxSeen = '1';
      plxEls.push(el);
    });

    root.querySelectorAll('.sf-photohero').forEach(function (el) {
      if (el.dataset.sfInit) return;
      el.dataset.sfInit = '1';
      setTimeout(function () { el.classList.add('sf-go'); }, 150);
    });

    root.querySelectorAll('.sf-filmhero').forEach(function (el) {
      if (el.dataset.sfInit) return;
      el.dataset.sfInit = '1';
      initFilmHero(el);
    });

    root.querySelectorAll('[data-sf-modes]').forEach(function (el) {
      if (el.dataset.sfInit) return;
      el.dataset.sfInit = '1';
      initModes(el);
    });

    root.querySelectorAll('[data-sf-gallery]').forEach(function (el) {
      if (el.dataset.sfInit) return;
      el.dataset.sfInit = '1';
      initGallery(el);
    });

    if (!reduced) updatePlx();
  }

  scan(document);

  /* re-scan when sections are re-rendered (theme editor, dev live-reload) */
  var pending = null;
  new MutationObserver(function (muts) {
    var needs = false;
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1) needs = true; });
    });
    if (!needs) return;
    clearTimeout(pending);
    pending = setTimeout(function () { scan(document); }, 80);
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
